import { systemEngineEnvironment } from "services/environment/systemEngine";

export const deleteServiceAccount = async (name: string) => {
  const result = await systemEngineEnvironment.execute<{ name: string }>(
    `DROP SERVICE ACCOUNT IF EXISTS "${name}"`
  );
  const [response] = result;
  return response.rows;
};
